import React from 'react';

import Page from '@common/components/app-layout/page';
import PageContent from '@common/components/app-layout/page-content';

import UtilityHeader from '@aware/common/utility-header';
import ConfigureLockdownBrowserView from '@aware/pages/configure-lockdown-browser/configure-ldb-view';

const ConfigureLockdownBrowser = () => {
  return (
    <>
      <UtilityHeader title="Configure LockDown Browser" />
      <Page>
        <PageContent>
          <ConfigureLockdownBrowserView />
        </PageContent>
      </Page>
    </>
  );
};

export default ConfigureLockdownBrowser;
